import * as c from 'common/c'

import { get, findIndex, cloneDeep } from 'es-toolkit/compat'
//representation of the object structure not an empty object.
declare module 'state/account.js' {
  interface country {
    name: string
    extent: number[]
  }
  interface options {
    countries: { [key: string]: country }
    languages: { [key: string]: string }
    units: { [key: string]: { [key: string]: string } }
  }
  interface user {
    createdAt: string
    email: string
    eusaDate: string
    fullName: string
    id: string
    isAgPro?: boolean
    phoneNumber: string
    tenantId: string
    updatedAt: string
  }

  type Tenant = {
    id?: string
    fullName?: string
    email?: string
    phoneNumber?: string
    streetAddress?: string
    postalCode?: string
    country?: string
    createdAt?: string
    updatedAt?: string
  }

  type Organization = {
    tenantId: string
    fullName: string
    email: string
    phoneNumber: string
    accountEnabled: boolean
    partnerName: string
  }

  type Operator = {
    id: string
    name: string
    tenantId: string
  }

  type TenantUser = {
    id: string
    fullName: string
    email: string
    role: string
    tenantId: string
    auth0UserId?: string
  }

  type Subscription = {
    createdAt: string
    id: number
    partnerTenantId?: string
    registrationDate: string
    subscriptionType: string
    tenantId: string
    updatedAt: string
    subscriptionPeriods: SubscriptionPeriod[]
  }
  type SubscriptionPeriod = {
    createdAt: string
    endDate: string
    harvestedArea: number
    id: number
    startDate: string
    subscriptionId: number
    subscriptionStatus: string
    tenantId: string
    updatedAt: string
  }
  type AccessibleAccount = {
    tenantId: string
    userId: string
    farmName: string
  }
  type customClaims = {
    'https://api.farmtrx.com/is_ft_admin': boolean
    'https://api.farmtrx.com/is_partner_admin': boolean
  }
  export interface Account {
    singleton: any
    options: options | {}
    editTenantBool: boolean
    auth: {
      isAuthenticated: boolean
      isLoading: boolean
    }
    hasToken: boolean
    hasTokenWithPermissionsRetries: number
    clients: []
    permissions: string[]
    token: undefined | string
    localState: {}
    accessibleAccounts: AccessibleAccount[]
    invitedUsers: []
    user: user | {}
    partnerContactDetails: Tenant | {}
    customClaims: customClaims
    subscriptions: Subscription[]
    currentSubscription?: SubscriptionPeriod
    userList: user[]
    operatorsList: Operator[]
    tenantUsers: TenantUser[]
  }
}

const initialState = {
  singleton: {},
  options: {},
  editTenantBool: false,
  auth: {
    isAuthenticated: false,
    isLoading: false,
  },
  hasToken: false,
  hasTokenWithPermissionsRetries: 0,
  organizations: [],
  clients: [],
  permissions: [],
  token: undefined,
  localState: {},
  accessibleAccounts: [],
  invitedUsers: [],
  userList: [],
  user: {},
  partnerContactDetails: {},
  subscriptions: [],
  currentSubscription: {},
  customClaims: undefined,
  operatorsList: [],
  tenantUsers: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.TENANT_FETCHED: {
      //@ts-expect-error
      return update(state, { singleton: { $set: action.payload } })
    }

    case c.EDIT_TENANT_BOOL: {
      //@ts-expect-error
      return update(state, { editTenantBool: { $set: action.payload } })
    }

    case c.OPTIONS_FETCHED: {
      //@ts-expect-error
      return update(state, { options: { $set: action.payload } })
    }

    case c.AUTH_DATA: {
      //@ts-expect-error
      return update(state, { auth: { $set: action.payload } })
    }

    case c.HAS_TOKEN: {
      //@ts-expect-error
      return update(state, { hasToken: { $set: true } })
    }

    case c.PERMISSIONS: {
      //@ts-expect-error
      return update(state, { permissions: { $set: action.payload } })
    }

    case c.SET_CUSTOM_CLAIMS: {
      //@ts-expect-error
      return update(state, { customClaims: { $set: action.payload } })
    }

    case c.HAS_TOKEN_WITH_PERMISSIONS_RETRIES: {
      //@ts-expect-error
      return update(state, {
        hasTokenWithPermissionsRetries: { $set: action.payload },
      })
    }

    case c.ORGANIZATIONS_FETCHED: {
      //@ts-expect-error
      return update(state, { organizations: { $set: action.payload } })
    }

    case c.CLIENTS_FETCHED: {
      //@ts-expect-error
      return update(state, { clients: { $set: action.payload } })
    }

    case c.SET_TOKEN: {
      //@ts-expect-error
      return update(state, { token: { $set: action.payload } })
    }

    case c.SET_LOCAL_TENANT_FORM_DATA: {
      //@ts-expect-error
      return update(state, { localState: { $set: action.payload } })
    }

    case c.ACCESSIBLE_ACCOUNTS_FETCHED: {
      //@ts-expect-error
      return update(state, { accessibleAccounts: { $set: action.payload } })
    }

    case c.INVITED_USERS_FETCHED: {
      //@ts-expect-error
      return update(state, { invitedUsers: { $set: action.payload } })
    }

    case c.USER_FETCHED: {
      //@ts-expect-error
      return update(state, { user: { $set: action.payload } })
    }

    case c.USER_LIST_FETCHED: {
      //@ts-expect-error
      return update(state, { userList: { $set: action.payload } })
    }

    case c.EUSA_ACCEPTED: {
      //@ts-expect-error
      return update(state, { user: { eusaDate: { $set: action.payload } } })
    }

    case c.EDIT_USER_ACCOUNT: {
      //@ts-expect-error
      return update(state, { user: { $set: action.payload } })
    }

    case c.CLIENT_UPDATED: {
      const organizations: Organization[] = get(state, 'organizations', [])
      const { data } = action.payload

      const index = findIndex(
        organizations,
        (organization) => organization.tenantId === data.id,
      )
      if (index > -1) {
        const organizationData = {
          accountEnabled: data.accountEnabled,
          tenantId: data.id,
          email: data.email,
          fullName: data.fullName,
          phoneNumber: data.phoneNumber,
          organizationName:
            data.organizationName ?? data.displayName ?? data.id,
        }
        //@ts-expect-error
        return update(state, {
          organizations: { $splice: [[index, 1, organizationData]] },
        })
      } else return
    }

    case c.CONTACT_INFO_FETCHED: {
      //@ts-expect-error
      return update(state, { partnerContactDetails: { $set: action.payload } })
    }

    case c.SUBSCRIPTIONS_FETCHED: {
      //@ts-expect-error
      return update(state, { subscriptions: { $set: action.payload } })
    }

    case c.HARVESTED_AREA_FETCHED: {
      const data = action.payload
      const subscriptions = cloneDeep(state.subscriptions)
      //@ts-expect-error
      const period = subscriptions[0]['subscriptionPeriods'].find(
        (p) => p.startDate === data.startDate && p.endDate === data.endDate,
      )
      if (period) {
        period['harvestedArea'] = data.harvestedAreaSqM
      }
      //@ts-expect-error
      return update(state, { subscriptions: { $set: subscriptions } })
    }

    case c.SUBSCRIPTION_PAYMENT_LINK_FETCHED: {
      const { paymentLink, startDate, endDate } = action.payload
      const subscriptions = cloneDeep(state.subscriptions)
      //@ts-expect-error
      const period = subscriptions[0]['subscriptionPeriods'].find(
        (p) => p.startDate === startDate && p.endDate === endDate,
      )
      period['paymentLink'] = paymentLink
      //@ts-expect-error
      return update(state, { subscriptions: { $set: subscriptions } })
    }

    case c.PAYMENT_INFO_FETCHED: {
      const { id, payload } = action.payload
      let period
      const subscriptions = cloneDeep(state.subscriptions)
      //@ts-expect-error
      period = subscriptions[0]['subscriptionPeriods'].find((p) => p.id === id)
      period['paymentInfo'] = payload
      //@ts-expect-error
      return update(state, { subscriptions: { $set: subscriptions } })
    }

    case c.CURRENT_SUBSCRIPTION_FETCHED: {
      //@ts-expect-error
      return update(state, { currentSubscription: { $set: action.payload } })
    }

    case c.SUBSCRIPTION_PAYMENT_FETCHED: {
      //@ts-expect-error
      return update(state, {
        subscriptionPaymentFetched: { $set: action.payload },
      })
    }

    case c.USER_PREFERENCE_FETCHED: {
      //@ts-expect-error
      return update(state, {
        user: {
          prefs: { $set: action.payload.prefs },
        },
      })
    }

    case c.OPERATORS_FETCHED: {
      //@ts-expect-error
      return update(state, {
        operatorsList: { $set: action.payload },
      })
    }

    case c.CREATE_OPERATOR: {
      const newOperator = action.payload
      const operatorsList = [...state.operatorsList, newOperator]
      //@ts-expect-error
      return update(state, { operatorsList: { $set: operatorsList } })
    }
    case c.UPDATE_OPERATOR: {
      const updatedOperator = action.payload
      const operatorsList: Operator[] = cloneDeep(state.operatorsList)
      const index = findIndex(
        operatorsList,
        (operator: Operator) => operator.id === updatedOperator.id,
      )
      if (index > -1) {
        operatorsList[index] = updatedOperator
        //@ts-expect-error
        return update(state, { operatorsList: { $set: operatorsList } })
      }
    }

    case c.DELETE_OPERATOR: {
      const id = action.payload
      const operatorsList: Operator[] = cloneDeep(state.operatorsList)
      const index = findIndex(
        operatorsList,
        (operator: Operator) => operator.id === id,
      )
      if (index > -1) {
        operatorsList.splice(index, 1)
        //@ts-expect-error
        return update(state, { operatorsList: { $set: operatorsList } })
      }
    }

    case c.TENANT_USERS_FETCHED: {
      //@ts-expect-error
      return update(state, {
        tenantUsers: { $set: action.payload },
      })
    }

    case c.CREATE_TENANT_USER: {
      const newUser = action.payload
      const tenantUsers = [...state.tenantUsers, newUser]
      //@ts-expect-error
      return update(state, { tenantUsers: { $set: tenantUsers } })
    }

    case c.UPDATE_TENANT_USER: {
      const updatedUser = action.payload
      const tenantUsers: TenantUser[] = cloneDeep(state.tenantUsers)
      const index = findIndex(
        tenantUsers,
        (user: TenantUser) => user.id === updatedUser.id,
      )
      if (index > -1) {
        tenantUsers[index] = updatedUser
        //@ts-expect-error
        return update(state, { tenantUsers: { $set: tenantUsers } })
      }
      return state
    }

    case c.DELETE_TENANT_USER: {
      const id = action.payload
      const tenantUsers: TenantUser[] = cloneDeep(state.tenantUsers)
      const index = findIndex(tenantUsers, (user: TenantUser) => user.id === id)
      if (index > -1) {
        tenantUsers.splice(index, 1)
        //@ts-expect-error
        return update(state, { tenantUsers: { $set: tenantUsers } })
      }
      return state
    }

    default:
      return state
  }
}
